import {
  FETCH_APPLICATION_DATA_SUCCESS,
  FETCH_APPLICATION_DATA_FAILURE,
  STORE_APP_DATA_URLS,
  SHOW_MODAL,
  SHOW_LOADER,
  STORE_LANGUAGE_CODE,
} from '../Actions/ActionTypes';

const initialState = {
  appData: null,
  appDataFailure: null,
  openedTabList: [],
  isModal: false,
};
/**
 * Reducer for Hub Page
 * @param  state
 * @param  action
 */
export default function HubReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPLICATION_DATA_SUCCESS:
      return {
        ...state,
        appData: action.payload,
        appDataFailure: null,
        openedTabList: [],
      };
    case FETCH_APPLICATION_DATA_FAILURE:
      return {
        appDataFailure: action.error,
        appData: null,
        openedTabList: [],
        isModal: false,
      };
    case STORE_APP_DATA_URLS:
      const openedList = [...state.openedTabList];
      openedList.push(action.openedTab);
      return {
        ...state,
        openedTabList: openedList,
      };
    case SHOW_MODAL:
      return {
        ...state,
        isModal: action.isModal,
      };
    case SHOW_LOADER:
      return {
        ...state,
        isLoader: action.isLoader,
      };
    case STORE_LANGUAGE_CODE:
      return {
        ...state,
        languageCode: action.languageCode,
      };
    default:
      return state;
  }
}
